// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createBrowserHistory } from 'history';
import * as queryString from 'query-string';

export const history = createBrowserHistory();

export function setQueryToCurrentPath(queryParams = {}) {
    const nonEmptyQueryParams = {};
    Object.keys(queryParams).forEach((key: string) => {
        if (queryParams[key]) {
            nonEmptyQueryParams[key] = queryParams[key];
        }
    });
    history.push(`?${queryString.stringify(nonEmptyQueryParams)}`);
}

export default history;
